<template>
    <div class="faq-section apprentice-simple-card">
        <design-2021-rating-edit-section-header-component
            :section-in="sectionIn"
            :rating-in="ratingIn"></design-2021-rating-edit-section-header-component>

        <div class="accordion container-fluid">
            <div class="rating-section">
                <b-form-group
                    class="description"
                    :label="$t('common.description')"
                    label-for="section-description-input">
                    <div class="section-description">
                        <ckeditor
                            id="section-description-input"
                            v-model="description"
                            :editor="editor"
                            :config="editorConfig"
                            @blur="updateSectionDescription()">
                        </ckeditor>
                    </div>
                </b-form-group>

                <div class="options">
                    <div class="apprentice-checkbox students">
                        <b-form-checkbox
                            v-model="personal"
                            v-on:change="updateSectionPersonal"
                            value="1"
                            unchecked-value="0"
                            >{{ $t('rating.by_student') }}
                        </b-form-checkbox>
                    </div>
                    <div class="apprentice-checkbox grades">
                        <b-form-checkbox
                            v-model="type"
                            v-on:change="updateSectionType"
                            :value="1"
                            :unchecked-value="0">
                            {{ $t('rating.with_grades') }}
                        </b-form-checkbox>
                    </div>
                </div>
            </div>

            <design-2021-rating-edit-item-component
                v-for="item in sectionIn.items"
                :key="item.id"
                :item="item"
                :section="sectionIn"
                :ref="`anchor-${item.id}`"></design-2021-rating-edit-item-component>

            <div class="add-item-rating">
                <button
                    class="btn btn-add btn-primary"
                    v-b-modal="'rating-edit-add-item-modal-' + sectionIn.id">
                    {{ $t('rating.new_item') }}
                </button>

                <design-2021-rating-edit-add-item-modal-component
                    :section="sectionIn"
                    :rating-in="ratingIn"></design-2021-rating-edit-add-item-modal-component>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import ApprenticeEditor from '../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-rating-edit-section-component',
    props: ['sectionIn', 'ratingIn'],
    components: {
        draggable,
    },
    data() {
        return {
            description: this.sectionIn.description !== null ? this.sectionIn.description : '',
            personal: this.sectionIn.personal,
            type: this.sectionIn.type,
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
        };
    },
    watch: {
        sectionIn: function (value) {
            this.description = value.description !== null ? value.description : '';
            this.personal = value.personal;
            this.type = value.type;
        },
    },
    methods: {
        updateSectionDescription() {
            const data = {
                description: this.description,
                id: this.sectionIn.id,
            };

            this.axios.post(this.routes.ratingSectionDescription(), data).then(
                (response) => {
                    this.sectionIn.update({ description: this.description });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateSectionPersonal(value) {
            const data = {
                personal: value,
                id: this.sectionIn.id,
            };

            this.axios.post(this.routes.ratingSectionPersonal(), data).then(
                (response) => {
                    this.sectionIn.update({ personal: value });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateSectionType(value) {
            const data = {
                type: parseInt(value),
                id: this.sectionIn.id,
            };

            this.axios.post(this.routes.ratingSectionType(), data).then(
                (response) => {
                    this.sectionIn.update({ type: value });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.rating-section {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

    .description {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .options {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        .students {
            margin-right: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}

.add-item-rating {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
